var _defineProperty = require('babel-runtime/helpers/define-property').default;

var _Object$keys = require('babel-runtime/core-js/object/keys').default;

(function () {
  Flint.file('mframework/views/slideTransitioner.js', function (require) {
    var _reactMotion = require('react-motion');

    Flint.staticStyles('SlideTransitioner', {
      '$': '#_flintapp .ViewSlideTransitioner',
      '$thing': '#_flintapp thing.SlideTransitioner, #_flintapp .SlideTransitioner.thing, #_flintapp .ViewSlideTransitioner.thing, #_flintapp .SlideTransitioner > .thing'
    }, {
      '$': {},
      '$thing': {
        position: 'absolute'
      }
    });
    Flint.view('SlideTransitioner', function (view, on, $) {
      var pro = initPro(view, {
        children: atom(),
        selectedIndex: M.defaultAtom(-1),
        springStiffness: M.defaultAtom(290),
        springDamping: M.defaultAtom(29),
        width: M.defaultAtom(100)
      });

      var desiredIndex = atom();
      pro.selectedIndex.react(function (propSelectedIndex) {
        if (propSelectedIndex != null) {
          desiredIndex.set(propSelectedIndex);
        }
      });

      var children = pro.children.derive(function (c) {
        return List(React.Children.toArray(c));
      });

      var selectedIndex = derivation(function () {
        return Math.min(desiredIndex.get(), children.get().size);
      });

      var makeSpring = function makeSpring(targetValue) {
        return (0, _reactMotion.spring)(targetValue, [pro.springStiffness.get(), pro.springDamping.get()]);
      };view.render(function () {
        return view.el(
          ['TransitionMotion', 1],
          {
            defaultStyles: (function () {
              return selectedIndex.get() == -1 ? {} : _defineProperty({}, selectedIndex.get(), {
                left: -pro.width.get()
              });
            })(),
            styles: (function () {
              return selectedIndex.get() == -1 ? {} : _defineProperty({}, selectedIndex.get(), {
                left: makeSpring(0)
              });
            })(),
            willEnter: function (i) {
              return {
                left: -pro.width.get()
              };
            },
            willLeave: function (i) {
              return {
                left: makeSpring(-pro.width.get())
              };
            }
          },
          function (styles) {
            return Flint.range(_Object$keys(styles)).map(function (_, _index) {
              return view.el(
                ['thing', 1, _, _index],
                { repeat: _Object$keys(styles), key: _, style: styles[_] },
                children.get().get(_)
              );
            });
          }
        );
      });
    });
  })
})();
//# sourceMappingURL=slideTransitioner.js.map
